export const TOGGLE_SETTING = 'TOGGLE_SETTING';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const PAGE_TITLE = 'PAGE_TITLE';
export const FILE_MANAGER = 'FILE_MANAGER';
export const ORI_FILE_MANAGER = 'ORI_FILE_MANAGER';
export const VERSION = 'VERSION';
export const APIBUILDNUMBER = 'APIBUILDNUMBER';
export const PAYMENTPROVIDER = 'PAYMENT_PROVIDER';
export const DEFAULT_TAKEPERROW = "DEFAULT_TAKEPERROW";


/**
 * Change a setting value
 * payload.name: name of the setting prop to change
 * payload.value: new value to apply
 */
export function changeSetting(name, value) {
    return { type: CHANGE_SETTING, name, value };
}

/**
 * Toggle a setting value (only boolean)
 */
export function toggleSetting(name) {
    return { type: TOGGLE_SETTING, name };
}

/**
 * Page title setting value (string)
 */
export function changePageTitle(value) {
    return { type : PAGE_TITLE, value }
}

/**
 * Page title setting value (string)
 */
export function setFileManagerUrl(value) {
    return { type : FILE_MANAGER, value }
}

export function setPaymentProvider(value) {
    return { type : PAYMENTPROVIDER, value }
}

export function setOriginalFileManagerUrl(value) {
    return { type : ORI_FILE_MANAGER, value }
}

export function setVersion(value) {
    return { type : VERSION, value }
}

export function setAPIBuildNumber(value) {
    return { type : APIBUILDNUMBER, value }
}

export function setDefaultTakePerRow(value) {
    return {type : DEFAULT_TAKEPERROW,value}
}

